export default __webpack_public_path__ + "static/media/cardbgstartup.946a02ea.png";